<template>
  <div class="content">
    <a-form ref="formRegister" :form="form" id="formRegister">

      <a-form-item>
        <a-input size="large" placeholder="11 位手机号" v-decorator="['phone', {rules: [{ required: true, message: '请输入正确的手机号', pattern: /^1[3456789]\d{9}$/ }, { validator: this.handlePhoneCheck } ], validateTrigger: ['change', 'blur'] }]">
          <a-select slot="addonBefore" size="large" defaultValue="+86">
            <a-select-option value="+86">+86</a-select-option>
            <a-select-option value="+87">+87</a-select-option>
          </a-select>
        </a-input>
      </a-form-item>

      <a-form-item>
        <validate-code ref="validateCode"></validate-code>
      </a-form-item>

      <a-row :gutter="16">
        <a-col class="gutter-row" :span="16">
          <a-form-item>
            <a-input size="large" type="text" placeholder="验证码" v-decorator="['verifycode', {rules: [{ required: true, message: '请输入验证码' }], validateTrigger: 'blur'}]">
              <a-icon slot="prefix" type="mail" :style="{ color: 'rgba(0,0,0,.25)' }"/>
            </a-input>
          </a-form-item>
        </a-col>
        <a-col class="gutter-row" :span="8">
          <a-button
            size="large"
            class="getCaptcha"
            :disabled="state.smsSendBtn"
            @click.stop.prevent="getCaptcha"
            v-text="!state.smsSendBtn && '获取验证码'||(state.time+' s')"></a-button>
        </a-col>
      </a-row>

      <a-form-item>
        <a-input
          size="large"
          placeholder="重新输入密码"
          type="password"
          v-decorator="[
            'password',
            {rules: [{ required: true, message: '请输入密码' }], validateTrigger: 'blur'}
          ]">
        </a-input>
      </a-form-item>

      <a-form-item>
        <a-input
          size="large"
          placeholder="再次输入密码"
          type="password"
          v-decorator="[
            'repassword',
            {rules: [{ required: true, message: '请再次输入密码' }, { validator: this.handlePasswordCheck }], validateTrigger: ['change','blur']}
          ]">
        </a-input>
      </a-form-item>

      <a-form-item>
        <a-button
          size="large"
          type="primary"
          htmlType="submit"
          class="register-button"
          :loading="registerBtn"
          @click.stop.prevent="handleSubmit"
          :disabled="registerBtn">提交
        </a-button>
      </a-form-item>
      <router-link class="login" :to="{ name: 'login' }">使用已有账户登录</router-link>
    </a-form>
  </div>
</template>

<script>
  // import Config from "../../utils/config";
  // import UserRouteTool from "../../utils/userRouteTool";
  import { getSmsCaptcha } from '@/api/login'
  import validateCode from '@/components/ValidateCode/validateCode.vue'
  import {depList,resetpasswd} from '@/api/common.js'
  export default {
    name: 'Repassword',
    components: {validateCode},
    data() {
      return {
        form: this.$form.createForm(this),

        state: {
          time: 60,
          smsSendBtn: false,
          passwordLevel: 0,
          passwordLevelChecked: false,
          percent: 10,
          progressColor: '#FF0000'
        },
        registerBtn: false,
        businssDept:[]
      }
    },
    created() {
      // location.href = Config.parameter.publicLoginUrl;
    },
    mounted() {
      depList().then(res => {
        if(res.code==1){
          if(window.environment == 'bz'){
            this.businssDept = res.result.filter(item=>item.name=='博众事业部')
          }else{
            this.businssDept = res.result
          }
        }
      })
      // this.$axios({
      //   method: 'get',
      //   url: '/bussdep/list'
      // }).then((res) => {
      //   if (res.data.code == 1) {
      //     this.businssDept = res.data.result||[]
      //   }else{
      //     // this.$message({type:"error",message:res.data.message})
      //   }
      // }).catch((error) => {
      //   console.log(error)
      // })
    },
    computed: {},
    methods: {
      handleSubmit () {
        const { form: { validateFields }, state, $router } = this
        validateFields({ force: true }, (err, values) => {
          if (!err) {
            console.log('123')
            var params = JSON.parse(JSON.stringify(values))
            // console.log(params)
            // params.delete(repassword)
            // console.log(params)
            resetpasswd(params).then(res=>{
              if (res.code==1) {
                state.passwordLevelChecked = false
                this.$message.success('修改成功')
                $router.push({ name: 'login'})
              }
            })
          }
        })
      },
      handlePasswordCheck (rule, value, callback) {
        const password = this.form.getFieldValue('password')
        if (value === undefined) {
          callback(new Error('请输入密码'))
        }
        if (value && password && value.trim() !== password.trim()) {
          callback(new Error('两次密码不一致'))
        }
        callback()
      },
      getCaptcha (e) {
        e.preventDefault()
        const { form: { validateFields }, state, $message, $notification } = this

        validateFields(['phone'], { force: true },
          (err, values) => {
            if (!err) {
              this.$refs.validateCode.checkValidateCodeUrl().then(res=>{
                if(res&&res.code==1){

                  state.smsSendBtn = true

                  const interval = window.setInterval(() => {
                    if (state.time-- <= 0) {
                      state.time = 60
                      state.smsSendBtn = false
                      window.clearInterval(interval)
                    }
                  }, 1000)

                  const hide = $message.loading('验证码发送中..', 0)

                  getSmsCaptcha({ phone: values.phone,type:2 }).then(res => {
                    if (res.code==1){
                      setTimeout(hide, 2500)
                      $notification['success']({
                        message: '提示',
                        description: '验证码发送成功',
                        duration: 8
                      })
                    }else{
                      this.$message.error(res.message)
                    }
                  }).catch(err => {
                    setTimeout(hide, 1)
                    clearInterval(interval)
                    state.time = 60
                    state.smsSendBtn = false
                    this.requestFailed(err)
                  })
                }
              })
            }
          }
        )
      },
      handlePhoneCheck (rule, value, callback) {
        // console.log('handlePhoneCheck, rule:', rule)
        // console.log('handlePhoneCheck, value', value)
        // console.log('handlePhoneCheck, callback', callback)

        callback()
      },
    }
  }
</script>

<style lang="less" scoped>
  .label-right{
    padding-right: 20px;
    color:rgba(0,0,0,.85);
    margin-top: 5px;
  }
  .content{
    width: 400px;
    padding: 20px;
    margin: 20px auto;
    border: 1px solid #efefef;
    box-shadow: 2px 2px 6px #dedede;
    background: #fff;
  }
  .user-layout-register {

    & > h3 {
      font-size: 16px;
      margin-bottom: 20px;
    }

    .getCaptcha {
      display: block;
      width: 100%;
      height: 40px;
    }

    .register-button {
      width: 50%;
    }

    .login {
      float: right;
      line-height: 40px;
    }
  }
</style>